import React, { memo } from 'react'

import SectionTitle from 'components/ui/SectionTitle'

/* styles */
import classes from 'pages/Home/MainBannerInner/index.module.scss'
import MissionSearch from '../../../modules/pages/Home/sections/MissionSearch'


const MainBannerInner = () => (
  <div className={classes.bannerWrapper}>
    <div className={classes.maxWidth}>
      <SectionTitle
        className={classes.bannerInner}
        item="searchBannerTitle"
        variant="white"
        spacing="mb-4"
      />
      <MissionSearch />
    </div>
  </div>
)

export default memo(MainBannerInner)
